import { api } from '../lib/api';

export interface AtaImagem {
  id: number;
  ata_id: number;
  url: string;
  descricao?: string;
  ordem: number;
  criado_em: string;
}

export interface ProjetoFoto extends AtaImagem {
  ata_numero: number;
  ata_data: string;
  ata_nome: string | null;
}

export async function getAtaImagens(ataId: string | number): Promise<AtaImagem[]> {
  const response = await api.get<AtaImagem[]>(`/ata-imagens/${ataId}`);
  return response.data;
}

export async function getProjetoFotos(projetoId: string | number): Promise<ProjetoFoto[]> {
  const response = await api.get<ProjetoFoto[]>(`/projetos/${projetoId}/fotos`);
  return response.data;
}

export async function uploadAtaImagem(
  ataId: string | number,
  file: File,
  descricao?: string
): Promise<AtaImagem> {
  const formData = new FormData();
  formData.append('imagem', file);
  if (descricao) {
    formData.append('descricao', descricao);
  }

  const response = await api.post<AtaImagem>(`/ata-imagens/${ataId}`, formData, {
    headers: {
      'Content-Type': undefined,
    },
  });
  return response.data;
}

export async function updateAtaImagem(
  ataId: string | number,
  imagemId: number,
  data: { descricao?: string; ordem?: number }
): Promise<AtaImagem> {
  const response = await api.patch<AtaImagem>(`/ata-imagens/${ataId}/${imagemId}`, data);
  return response.data;
}

export async function deleteAtaImagem(
  ataId: string | number,
  imagemId: number
): Promise<void> {
  await api.delete(`/ata-imagens/${ataId}/${imagemId}`);
}

export async function reordenarAtaImagens(
  ataId: string | number,
  ordem: number[]
): Promise<AtaImagem[]> {
  const response = await api.post<AtaImagem[]>(`/ata-imagens/${ataId}/reordenar`, { ordem });
  return response.data;
}
